import { FC, ReactNode } from "react";

import { Badge } from "@mui/material";

interface IPlannedDayBadgeProps {
  children: ReactNode;
  "data-testid"?: string;
}

const PlannedDayBadge: FC<IPlannedDayBadgeProps> = ({
  children,
  "data-testid": dataTestId,
}) => (
  <Badge
    badgeContent=""
    variant="dot"
    overlap="circular"
    data-testid={dataTestId}
    sx={{ "& .MuiBadge-dot": { backgroundColor: "#EF6C00" } }}
  >
    {children}
  </Badge>
);

export default PlannedDayBadge;
